// plan-delete-guard.js — the client half of the pinned-plan delete guard.
// ---------------------------------------------------------------------
// 2026-08-20 — Midland incident close-out. Brett's 25 offline pins synced
// perfectly on 14 Aug, then were destroyed the same morning when the plan
// was deleted to force a re-import (pre-v0.142.0, the only way to fetch a
// missing scale). The confirm dialog at the time said the file "just stops
// appearing in this report's plan list" — which was false: DELETE
// /api/drawings/:id deletes the drawing AND strips DrawingId/MarkX/MarkY
// off every defect pinned to it, unrecoverably.
//
// The server now answers 409 with the pin count when a plan has pins and
// the caller has not sent ?unpin=1 (see api/drawings/index.js). This module
// is the decision logic between those two calls, kept pure so it is tested:
// which URL to call, whether an error is the guard speaking (retry after a
// real confirmation) or an actual failure (stop and say so).

/** Build the DELETE url. `acknowledged` = the user has been told the true
 *  pin count and still said yes. */
export function drawingDeleteUrl(drawingId, acknowledged = false) {
  return `/api/drawings/${drawingId}${acknowledged ? '?unpin=1' : ''}`;
}

/** Is this error the server's pinned-plan guard (retry-able after consent),
 *  as opposed to a real failure? apiSend attaches `status` to thrown errors. */
export function isPinConflict(err) {
  return Number(err && err.status) === 409;
}

/** The sentence to put in front of the user before the acknowledged retry.
 *  The server's 409 message already states the count truthfully; we add the
 *  question. Falls back to a safe generic if the message is missing. */
export function unpinConfirmMessage(err) {
  const serverSentence = (err && err.message) ? String(err.message) : 'This plan has pinned items. Deleting it removes their pins permanently.';
  return `${serverSentence}\n\nDelete the plan anyway?`;
}
